import React, { useState } from "react";
import styles from "./FAQSection.module.css";
import { Container } from "../../common/Container";
import { faqData } from "../../../data/tidePostData";
import { useIntersectionObserver } from "../../../hooks/useIntersectionObserver";
import clsx from "clsx";

const ChevronIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <path d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
  </svg>
);

export const FAQSection: React.FC = () => {
  const [openId, setOpenId] = useState<string | null>(null);
  const [ref, isVisible] = useIntersectionObserver<HTMLElement>({
    threshold: 0.1,
    triggerOnce: true,
  });

  const toggleFaq = (id: string) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section id="faq" className={styles.section} ref={ref}>
      <Container maxWidth="md">
        <div className={clsx(styles.content, isVisible && styles.visible)}>
          <div className={styles.header}>
            <span className={styles.label}>FAQ</span>
            <h2 className={styles.title}>Frequently Asked Questions</h2>
            <p className={styles.subtitle}>
              Everything you need to know about Tide Post
            </p>
          </div>

          <div className={styles.faqList}>
            {faqData.map((faq) => (
              <div
                key={faq.id}
                className={clsx(styles.faqItem, openId === faq.id && styles.faqItemOpen)}
              >
                <button
                  className={styles.faqQuestion}
                  onClick={() => toggleFaq(faq.id)}
                  aria-expanded={openId === faq.id}
                  aria-controls={`faq-answer-${faq.id}`}
                >
                  <span>{faq.question}</span>
                  <span className={styles.chevron}>
                    <ChevronIcon />
                  </span>
                </button>
                <div
                  id={`faq-answer-${faq.id}`}
                  className={styles.faqAnswer}
                  role="region"
                  aria-hidden={openId !== faq.id}
                >
                  <p>{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </section>
  );
};
